import {
  takeEvery, put, select,
} from 'redux-saga/effects';

import { ISpinnerData, IFirstSpinner } from 'src/typings/spinner';
import { getCurrentSpinner } from 'src/store/spinner/selectors';

import { Actions as ActionsApp } from 'src/store/app/actions';
import { Actions as ActionsFloors } from '../../floors/actions';
import { ActionTypes } from './actions';
import { Actions as ActionsSpinnerState } from '../../spinner/actions';

export const getInitialFloorContext = (spinners: ISpinnerData['spinners']) => {
  const firstSpinner = spinners?.firstSpinner;
  if (firstSpinner?.name !== 'floor' || !firstSpinner['name-id']) return null;

  const floorId = firstSpinner['name-id'];
  const floorData = spinners.floor?.[floorId]?.additional_data;
  if (!floorData) return null;

  return {
    floorId,
    floorNumber: floorData['floor.numeration'],
    houseId: floorData.house_id,
    sectionId: floorData.section_id,
  };
};

export function* setCurrentSpinner(actions: {
  type: string,
  payload: ISpinnerData
}) {
  const currentSpinner: IFirstSpinner = yield select(getCurrentSpinner);
  const {
    spinners,
  } = actions.payload;

  if (currentSpinner === null && spinners.firstSpinner.name && spinners.firstSpinner['name-id']) {
    yield put(ActionsSpinnerState.setCurrentSpinner({
      name: spinners.firstSpinner.name,
      'name-id': spinners.firstSpinner['name-id'],
    }));
    yield put(ActionsApp.setCurrentEntity({
      name: spinners.firstSpinner.name,
      id: spinners.firstSpinner['name-id'],
    }));

    // 15.07.2020 we a hurry. We didn't have any complex and we had only house spinner
    // Needed implement visibility for floors
    if (spinners.firstSpinner.name === 'house') {
      yield put(ActionsFloors.setSelectedHouse({
        name: spinners.firstSpinner.name,
        'name-id': spinners.firstSpinner['name-id'],
      }));
    }

    const initialFloorContext = getInitialFloorContext(spinners);
    if (initialFloorContext) {
      const {
        floorId, floorNumber, houseId, sectionId,
      } = initialFloorContext;

      if (houseId) {
        yield put(ActionsFloors.setSelectedHouse({
          name: 'house',
          'name-id': houseId,
        }));
      }
      if (sectionId) {
        yield put(ActionsFloors.setSelectedSection({
          markup: 'section_id',
          'markup-id': sectionId,
        }));
      }
      yield put(ActionsFloors.setSelectedFloor(floorId));
      if (floorNumber) {
        yield put(ActionsFloors.setSelectedFloorNumber(floorNumber));
      }
    }
  }
}

export function* getSpinnerWatchSaga() {
  yield takeEvery(ActionTypes.GET_SPINNER_DATA_REQUEST_SUCCESS, setCurrentSpinner);
}
